import { Box, Dialog, Divider, Typography } from "@mui/material";
import React from "react";
import { FormErrorDialog } from "../../../../../components/form-error-dialog/form-error-dialog.component";
import { View } from "../../../../../utils/view";
import { BuzzfeedQuizPost } from "../../../../post.models";
import {
  BuzzfeedQuizController,
  BuzzfeedQuizState,
  QuizCompletionCallback,
} from "../../buzzfeed_quiz.controller";
import { BuzzfeedQuestionComponent } from "../question/question.component";
import { QuizNavigationRow } from "../quiz-navigation-row/quiz-navigation-row.component";

import { QuizResult } from "../quiz-result/quiz-result.component";
import "./quiz-dialog.component.css";

export interface QuizDialogProps extends BuzzfeedQuizPost {
  controller: BuzzfeedQuizController;
  onQuizCompleted: QuizCompletionCallback;
}

/**
 * Represent an entire buzzfeed quiz in the social media emulator.
 */
export class QuizDialogComponent extends View<
  QuizDialogProps,
  BuzzfeedQuizState,
  BuzzfeedQuizController
> {
  constructor(props: QuizDialogProps) {
    super(props, props.controller);
  }

  render() {
    let backgroundImage;
    let backgroundSize;

    if (this.state.question?.backgroundImage != null) {
      backgroundImage = `url(${this.state.question?.backgroundImage})`;
      backgroundSize = "cover";
    }

    if (this.state.viewingResult) {
      return (
        <QuizResultDialog
          props={this.props}
          state={this.state}
          controller={this.controller}
        />
      );
    } else {
      return (
        <QuizQuestionDialog
          props={this.props}
          state={this.state}
          controller={this.controller}
        />
      );
    }
  }
}

export interface _InnerQuizProps {
  state: BuzzfeedQuizState;
  props: QuizDialogProps;
  controller: BuzzfeedQuizController;
}

export class QuizResultDialog extends React.Component<_InnerQuizProps> {
  render() {
    return (
      <React.Fragment>
        <Dialog
          open={this.props.state.viewingResult && this.props.state.viewingQuiz}
          onClose={this.props.controller.onQuizCompleted}
          id={`${this.props.props.id}-buzzfeed-result`}
        >
          <QuizResult
            {...this.props.state.result!}
            onResultConfirmed={this.props.controller.onQuizCompleted}
          />
        </Dialog>
      </React.Fragment>
    );
  }
}

/**
 * Represent an entire buzzfeed quiz in the social media emulator.
 */
export class QuizQuestionDialog extends React.Component<_InnerQuizProps> {
  constructor(props: _InnerQuizProps) {
    super(props, props.controller);
  }

  render() {
    let backgroundImage;
    let backgroundSize;

    if (this.props.state.question?.backgroundImage != null) {
      backgroundImage = `url(${this.props.state.question?.backgroundImage})`;
      backgroundSize = "cover";
    }

    return (
      <React.Fragment>
        <Dialog
          open={this.props.state.viewingQuiz}
          onClose={this.props.controller.onQuizCancelled}
          id={`${this.props.props.id}-buzzfeed-quiz`}
        >
          <Box
            className="quiz-dialog-wrapper"
            sx={{
              backgroundImage: backgroundImage,
              backgroundSize: backgroundSize,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                padding: "10px",
                backgroundColor: "quizTitle.main",
                color: "quizTitle.contrastText",
              }}
            >
              {this.props.props.title}
            </Typography>
            <Divider />
            <BuzzfeedQuestionComponent
              question={this.props.state.question}
              currentResponse={this.props.state.currentSelectedResponse}
              onResponseSelected={this.props.controller.onResponseSelected}
              id={this.props.props.id}
            />
            <Box sx={{ height: "10px" }} />
            <QuizNavigationRow
              onPreviousPageClicked={
                this.props.controller.onPreviousPageClicked
              }
              onNextPageClicked={this.props.controller.onNextPageClicked}
              firstPage={this.props.state.firstPage}
              lastPage={this.props.state.lastPage}
            />
          </Box>
        </Dialog>
        <FormErrorDialog
          controller={this.props.controller.pageErrorController}
        />
      </React.Fragment>
    );
  }
}
